import { createHashRouter, createRoutesFromElements, Route } from "react-router-dom";
import { ErrorBoundary } from "../components/error/ErrorBoundary";
import AppLayout from "../layout/AppLayout";
import { suspendPageLoad } from "./suspendPageLoad";

const Dashboard = suspendPageLoad(() => import("../pages/newDashboard/NewDashboardPage"));
const OldDashboard = suspendPageLoad(() => import("../pages/dashboard/DashboardPage"));
const VehicleHeader = suspendPageLoad(() => import("../pages/vehicleHealth/components/VehicleHealth"));
const Alerts = suspendPageLoad(() => import("../pages/alerts/AlertsPage"));
const Notifications = suspendPageLoad(() => import("../pages/notifications/NotificationsPage"));
const Recurrence = suspendPageLoad(() => import("../pages/recurrence/RecurrencePage"));
const Downtime = suspendPageLoad(() => import("../pages/downtime/DowntimePage"));
const Details = suspendPageLoad(() => import("../pages/details/DetailsPage"));
const DetailsVehiclePage = suspendPageLoad(() => import("../pages/vehicleHealth/detailsHealth/DetailsVehiclePage"));

export const DEFAULT_ROUTE = "/dashboard";
export const OLD_DASHBOARD = "/OldDashboard";
export const HEALTH = "/vehicleHealth";
export const ALERTS_ROUTE = "/alerts";
export const NOTIFICATIONS_ROUTE = "/notifications";
export const RECURRENCE_ROUTE = "/recurrence";
export const DOWNTIME_ROUTE = "/downtime";
export const DETAILS_ROUTE = "/details/:assetId";
export const DETAILS_HEALTH = "/detailsHealth/:assetId";

export const routes = [
	DEFAULT_ROUTE,
	HEALTH,
	ALERTS_ROUTE,
	NOTIFICATIONS_ROUTE,
	RECURRENCE_ROUTE,
	DOWNTIME_ROUTE,
	"/detailsHealth/",
	"/details/",
];

export const router = createHashRouter(
	createRoutesFromElements(
		<Route path="/" element={<AppLayout />}>
			<Route path={DEFAULT_ROUTE} errorElement={<ErrorBoundary />} element={<Dashboard />} />
			<Route path={OLD_DASHBOARD} errorElement={<ErrorBoundary />} element={<OldDashboard />} />
			<Route path={HEALTH} errorElement={<ErrorBoundary />} element={<VehicleHeader />} />
			<Route path={ALERTS_ROUTE} errorElement={<ErrorBoundary />} element={<Alerts />} />
			<Route path={NOTIFICATIONS_ROUTE} errorElement={<ErrorBoundary />} element={<Notifications />} />
			<Route path={RECURRENCE_ROUTE} errorElement={<ErrorBoundary />} element={<Recurrence />} />
			<Route path={DOWNTIME_ROUTE} errorElement={<ErrorBoundary />} element={<Downtime />} />
			<Route path={DETAILS_ROUTE} errorElement={<ErrorBoundary />} element={<Details />} />
			<Route path={DETAILS_HEALTH} errorElement={<ErrorBoundary />} element={<DetailsVehiclePage />} />
		</Route>,
	),
);
